import { render } from "./product-stepper.vue?vue&type=template&id=53ef70a1"
import script from "./product-stepper.vue?vue&type=script&lang=js"
export * from "./product-stepper.vue?vue&type=script&lang=js"
script.render = render

export default script